import { all, call } from "redux-saga/effects";
import { contentLibrarySaga } from "../containers/ContentLibrary/saga/contentLibrarySaga";
import { StudentdashboardSaga } from "../containers/NewStudentDashboard/saga/StudentdashboardSaga";
import { RosteringTabSaga } from "../containers/Rostering/saga/rosterSaga";
import { assignmentSaga } from "../containers/Assignments/saga/assignmentSaga";
import { autoGradeSaga } from "../containers/AutoGrade/saga/autoGradeSaga";

export function* watcherSaga() {
  yield all([
    call(contentLibrarySaga),

    call(StudentdashboardSaga),
    call(assignmentSaga),
    call(autoGradeSaga),
    call(RosteringTabSaga),
  ]);
}
